<template>
  <b-modal v-model="showModal" size="l" :hideHeaderClose='true' :noCloseOnBackdrop="true" hide-footer hide-header no-close-on-esc>
    <QuickProfileV1Internal @emitCloseQuickProfileV1Internal="close" />
    <b-toast
      v-model="showToast"
      name="Toast"
      :variant="toastVariant"
      :title="toastTitle">
      <div v-html="toastMsg">
      </div>
    </b-toast>
  </b-modal>
</template>
<style lang="scss">
.ResendSpan {
  color: var(--iq-primary);
  cursor: pointer;
  float: right;
}
input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  margin: 0;
}
.clearSpanIcon {
  position: absolute;
  right: 12px;
  top: 37px;
  font-size: 20px;
  cursor: pointer;
}
</style>
<script>
import QuickProfileV1Internal from "./QuickProfileV1Internal.vue"

export default {
  name: "UserVerificationInternal",
  props: {
    propOpenModal: {
      default: false
    }
  },
  components: {
    QuickProfileV1Internal
  },
  computed: {
    userData () {
      return { ...this.$store.getters["User/userData"] }
    }
  },
  data () {
    return {
      showQuickProfile: true,
      addSchoolShow: false,
      showModal: false,
      showModelAskOtpBox: false,
      showToast: false,
      toastMsg: null,
      toastVariant: "default",
      toastTitle: "User Verification"
    }
  },
  async mounted () {
    if (this.propOpenModal) {
      this.showModal = true
    }
  },
  methods: {
    /**
     * close
     */
    close () {
      this.showModelAskOtpBox = false
      this.$emit("emitCloseOtpModal", true)
    }
  }
}
</script>
